import { Button } from 'antd';

interface CancelButtonProps {
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  disabled?: boolean;
}

const CancelButton: React.FC<CancelButtonProps> = ({ onClick, disabled = false }) => {
  return (
    <Button
      size="small"
      onClick={onClick}
      disabled={disabled}
      style={{ marginRight: 8 }}
    >
      Cancel
    </Button>
  );
};

export default CancelButton;